import React, { useEffect } from "react";

import { Status, Divider } from "~components";
import { useScanReports } from "~features/reports/hooks/useScanReports";
import { Card } from "~components/reports";
import { getGraphData } from "~pages/pos/reporting";

import { Chart } from "../../pos/Chart";

import { ScansChart } from "./ScansChart";
import { ScansOverview } from "./ScansOverview";

type ScansProps = {
  sourceId: string;
};

export const Scans = ({ sourceId }: ScansProps) => {
  const { scanTicketTypes, scansOverTime, scanVisitors } = useScanReports({
    eventId: sourceId,
  });

  return (
    <>
      <ScansOverview
        data={scanTicketTypes.data?.scanTicketTypes}
        error={scanTicketTypes.error}
      />

      <Card title="Scanning breakdown" mb={4}>
        <Status loading={scanVisitors.isLoading} error={scanVisitors.error}>
          {scanVisitors.data?.scanVisitors?.length > 0 ? (
            <Chart data={getGraphData(scanVisitors.data?.scanVisitors)} />
          ) : (
            "Nothing scanned yet."
          )}
        </Status>

        <Divider my={3} />
      </Card>

      <Card title="Scanned visitors over time" mb={4}>
        <Status loading={scansOverTime.isLoading} error={scansOverTime.error}>
          {scansOverTime.data?.scanVisitorsOverTime?.length > 0 ? (
            <ScansChart
              data={scansOverTime.data?.scanVisitorsOverTime}
              timeBased
            />
          ) : (
            "Nothing scanned yet."
          )}
        </Status>

        <Divider my={3} />
      </Card>

      <Card title="Scanned percentage" mb={4}>
        <Status loading={scanVisitors.isLoading} error={scanVisitors.error}>
          {scanVisitors.data?.scanVisitors?.length > 0 ? (
            <ScansChart
              data={getGraphData(scanVisitors.data?.scanVisitors)}
              percentageBased
            />
          ) : (
            "Nothing scanned yet."
          )}
        </Status>

        <Divider my={3} />
      </Card>
    </>
  );
};

export default Scans;
